/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MaintenanceEventApi } from './maintenanceEventApi';

export type GenericApiResponseMaintenanceEventApiData = MaintenanceEventApi | null;
